
<div class="warranty-message">
    <inc-warranty
        v-model="showDialog"
        :warrenties="warrenties"
        :component="component"
    />
    <v-tooltip
        bottom
    >
        <template v-slot:activator="{ on, attrs }">
            <a @click="onClick">
                <v-icon
                    color="error"
                    size="30"
                    v-bind="attrs"
                    v-on="on"
                >
                    mdi-alert
                </v-icon>
            </a>
        </template>
        <span style="font-size: 10pt">Gewährleistung beachten</span>
    </v-tooltip>
</div>
